import { useVariant } from '@calendly/feature-check-react'

import { hasUserFeatureIntentKey } from 'services/user_feature_intent'

const SURFACE_ET_PAYMENTS_UPFRONT_EXPERIMENT_KEY = 'growth_surface_et_payments_upfront'
const COLLECT_PAYMENT_FEATURE_KEY = 'collect_payment'

const SURFACE_ET_PAYMENTS_UPFRONT_VARIANTS = {
  CONTROL: 'control',
  VARIANT_1: 'variant_1',
  VARIANT_2: 'variant_2',
}

const hasCollectPaymentIntroFeature = (userFeatureIntent) => hasUserFeatureIntentKey(userFeatureIntent, COLLECT_PAYMENT_FEATURE_KEY)

export const isSurfaceEtPaymentsUpfrontEligible = (userFeatureIntent) => hasCollectPaymentIntroFeature(userFeatureIntent)

const getSurfaceEtPaymentsUpfrontVariant = (variant) => (
  [
    SURFACE_ET_PAYMENTS_UPFRONT_VARIANTS.VARIANT_1,
    SURFACE_ET_PAYMENTS_UPFRONT_VARIANTS.VARIANT_2
  ].includes(variant) ? variant : null
)

export const SurfaceEtPaymentsUpfrontExperiment = ({ children }) => {
  const variant = useVariant(SURFACE_ET_PAYMENTS_UPFRONT_EXPERIMENT_KEY)

  return children(getSurfaceEtPaymentsUpfrontVariant(variant))
}
